import { Component, OnInit } from '@angular/core';
import { FakDokumentStavka } from './fak-dokument-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-fak-dokument-stavka-modal-update',
  templateUrl: './fak-dokument-stavka-modal-update.component.html'
})
export class FakDokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<FakDokumentStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<FakDokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  

}
